import React, { createContext, useState, useEffect } from 'react';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [authKey, setAuthKey] = useState(localStorage.getItem('apiKey') || null); // Updated for API Key

  useEffect(() => {
    if (authKey) {
      localStorage.setItem('apiKey', authKey); // Store API Key in local storage
    } else {
      localStorage.removeItem('apiKey'); // Remove API Key if null
    }
  }, [authKey]);

  return (
    <AuthContext.Provider value={{ authKey, setAuthKey }}>
      {children}
    </AuthContext.Provider>
  );
};
